import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

import TokenStore from '../stores/TokenStore';
import CurrentOrganizationIdStore from '../stores/CurrentOrganizationIdStore';
import UserAPI from '../util/UserAPI';


const AdminActions = {

  initializeSite() {
    const subdomain = location.hostname.split('.').shift();

    if (subdomain.substring(0, 6).toLowerCase() !== 'bluehq') {
      // This will only get called pre-login, so there will be no token
      AppDispatcher.dispatch({
        actionType: Constants.Admin.LOGIN_STYLING_REQUESTED,
      });

      new UserAPI(null).users.getOrgWithSiteUrl(subdomain).then((response) => {
        AppDispatcher.dispatch({
          actionType: Constants.Admin.LOGIN_STYLING_LOADED,
          styling: response.organization_styling.styling,
        });
      }).catch((e) => {
        console.warn('Could not load login styling', e);
        AppDispatcher.dispatch({
          actionType: Constants.Admin.LOGIN_STYLING_NOT_FOUND,
        });
      });
    }
  },

  setOrganization(orgId) {
    AppDispatcher.dispatch({
      actionType: Constants.Admin.ORGANIZATION_SET,
      organizationId: orgId,
    });
  },

  requestOrganizationData(orgId) {
    new UserAPI(TokenStore.getToken()).users.getOrganization(orgId).then((response) => {
      AppDispatcher.dispatch({
        actionType: Constants.Admin.ORGANIZATION_LOADED,
        organization: response.organization,
      });
    });
  },

  updateMembership(userId, organizationId, roleId, tableauUser, deletedTableauUser) {
    new UserAPI(TokenStore.getToken()).users
      .updateMembership(userId, organizationId, roleId)
      .then((membership) => {
        // update if there is a value for tableauUser or if it has been deleted
        if (tableauUser || deletedTableauUser) {
          const tableauUserForAPI = (deletedTableauUser ? null : tableauUser);
          new UserAPI(TokenStore.getToken()).users
            .updateMembershipDetail(userId, organizationId, tableauUserForAPI)
            .then((membershipDetail) => {
              AppDispatcher.dispatch({
                actionType: Constants.Admin.MEMBERSHIP_UPDATED,
                membership,
              });
            });
        } else {
          AppDispatcher.dispatch({
            actionType: Constants.Admin.MEMBERSHIP_UPDATED,
            membership,
          });
        }
      });
  },

  createUser(email, organizationId, roleId, tableauUser) {
    new UserAPI(TokenStore.getToken()).users.createUser(email, organizationId, roleId)
      .then((user) => {
        if (tableauUser) {
          new UserAPI(TokenStore.getToken()).users
            .updateMembershipDetail(user.membership.user.id, organizationId, tableauUser)
            .then((membershipDetail) => {
              AppDispatcher.dispatch({
                actionType: Constants.Admin.MEMBERSHIP_CREATED,
                membership: user.membership,
              });
            });
        } else {
          AppDispatcher.dispatch({
            actionType: Constants.Admin.MEMBERSHIP_CREATED,
            membership: user.membership,
          });
        }
      });
  },

  requestDeleteMembership(userId, organizationId) {
    new UserAPI(TokenStore.getToken()).users.deleteMembership(userId, organizationId)
      .then((response) => {
        AppDispatcher.dispatch({
          actionType: Constants.Admin.MEMBERSHIP_DELETED,
          response,
        });
      });
  },

  requestUserData(userId) {
    AppDispatcher.dispatch({
      actionType: Constants.Admin.USER_DATA_REQUESTED,
      userId: +userId,
    });
    new UserAPI(TokenStore.getToken()).users.getUser(userId).then((response) => {
      AppDispatcher.dispatch({
        actionType: Constants.Admin.USER_DATA_LOADED,
        userId: +userId,
        payload: response.user,
      });
    });
  },

  loadUsersForCurrentOrganization() {
    this.loadUserList(CurrentOrganizationIdStore.getState());
  },

  loadUserList(organizationId) {
    new UserAPI(TokenStore.getToken()).users.getActiveUsers(organizationId).then((response) => {
      AppDispatcher.dispatch({
        actionType: Constants.Admin.USER_LIST_LOADED,
        users: response.simple_users,
      });
    });
  },

  loadDaemonUserList(organizationId) {
    new UserAPI(TokenStore.getToken()).users.getDaemonUsers(organizationId).then((response) => {
      AppDispatcher.dispatch({
        actionType: Constants.Daemons.DAEMONS_RECEIVED,
        daemonUsers: response.simple_users || [],
      });
    });
  },
};

export default AdminActions;
